import AudienceMenubar from './AudienceMenubar'
import ChannelMenubar from './ChannelMenubar'
import DefaultMenubar from './DefaultMenubar'
import DialogueMenubar from './DialogueMenubar'
import {EmbedContext} from 'components/EmbedContext'
import {MenubarViewProps} from './types'
import React from 'react'
import {styled} from '../../stitches/config'
import {styledMenubar} from './styles/Menubar'

const StyledMenubar = styled('div', styledMenubar)

const MenubarView = (props: MenubarViewProps): React.ReactElement | null => {
    const {
        chatProps,
        name,
        routeParams,
    } = props

    const embed = React.useContext(EmbedContext)

    // prevent rendering menubar for embed
    if (embed && embed?.hideMenubar && !chatProps) {
        return null
    }

    return (
        <StyledMenubar>
            {!!chatProps &&
                <>
                    {!!chatProps.chat.channel_id &&
                        <>
                            {!!chatProps.isAudienceChannel &&
                                <AudienceMenubar
                                    chat={chatProps.chat}
                                    isActiveVideoChannel={chatProps.isActiveVideoChannel}
                                    isChannelSidebarOpen={chatProps.isChannelSidebarOpen}
                                    isChatOpen={chatProps.isChatOpen}
                                    // eslint-disable-next-line react/jsx-handler-names
                                    onToggleChannelSidebar={chatProps.onToggleChannelSidebar}
                                />}
                            {!chatProps.isAudienceChannel &&
                                <ChannelMenubar
                                    chat={chatProps.chat}
                                    isActiveVideoChannel={chatProps.isActiveVideoChannel}
                                    isChannelSidebarOpen={chatProps.isChannelSidebarOpen}
                                    isChatOpen={chatProps.isChatOpen}
                                    // eslint-disable-next-line react/jsx-handler-names
                                    onToggleChannelSidebar={chatProps.onToggleChannelSidebar}
                                />}
                        </>}
                    {!!chatProps.chat.user_id &&
                        <DialogueMenubar
                            chat={chatProps.chat}
                            isChannelSidebarOpen={chatProps.isChannelSidebarOpen}
                            // eslint-disable-next-line react/jsx-handler-names
                            onToggleChannelSidebar={chatProps.onToggleChannelSidebar}
                        />}
                </>}
            {!chatProps &&
                <DefaultMenubar name={name} routeParams={routeParams} />}
        </StyledMenubar>
    )
}

export default MenubarView
